import gql from 'graphql-tag'

export const GET_EXCHANGE_RATE_GROUPS_QUERY = gql`
	query(
		$skip: Int!
		$take: Int!
		$orderBy: [OrderByInput!]
	) {
		getExchangeRateGroups(
			data: { orderBy: $orderBy, pagination: { skip: $skip, take: $take } }
		) {
			items {
				id
				createdAt
				fromDate
				defaultCurrencyTitle
				defaultCurrency {
					title
					symbol
					main
				}
				rates {
					id
					currencyTitle
					currency {
						title
						symbol
						main
					}
					value
				}
			}
			total
			hasMore
		}
	}
`;

export const GET_EXCHANGE_RATE_GROUP_EXTRA_QUERY = gql`
  query {
    getAllCurrencies {
      title
      symbol
      left
			main
    }
		getMainCurrency {
			title
			symbol
		}
		getCurrentExchangeRateGroup {
			id
			defaultCurrency {
				title
				symbol
				main
			}
			rates {
				id
				currency {
					title
					symbol
					main
				}
				value
			}
		}
  }
`;
